import {ReactElement} from 'react'
import api from '../lib/api'

export const getPipeline=async(params?:Record<string, any>)=>{
    const {data}=await api.get(`/report/pipeline/`,{params})
    
    return data;
}
export const getFunding = async (params?: Record<string, any>) => {
  const { data } = await api.get("/report/funding/", { params })
  return data
}

export const getCompliance = async (params?: Record<string, any>) => {
  const { data } = await api.get("/report/compliance/", { params })
  return data
}
export const getTeam = async (params?: Record<string, any>) => {
  const { data } = await api.get("/report/team/", { params })
  return data
}
export const getDeadlines = async (params?: Record<string, any>) => {
  const { data } = await api.get("/report/deadlines/", { params })
  return data
}
export const getAIReport = async (params?: Record<string, any>) => {
  const { data } = await api.get("/report/ai/", { params })
  return data
}
